// Copyright 2005-2011 David Caldwell <david@greenfelt.net>, Jim Radford <radford@greenfelt.net>

var sht = require('./sht');
var solitaire = require('./solitaire').games;
var piles = require('./piles'), in_off_color_order=piles.in_off_color_order, drag_max_given_free=piles.drag_max_given_free;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.freecell = class extends sht {
    static {
        this.prototype.work_pile = class extends sht.prototype.work_pile {
                card_order = in_off_color_order;
                drag_max() { return (this.game.freetemps()+1) * drag_max_given_free(this.game.work,this); }
                valid_top_card(card) { return true; } // Accept any card in a blank space
                maxstack = Math.ceil(9.77615472612623); // Determined by query in upgrades/maxstack.sql
        };
        this.prototype.work_piles = 8;
    }
    layout = grid(["temp1", "temp2", "temp3", "temp4", "good1", "good2", "good3", "good4"],
                  ["work1", "work2", "work3", "work4", "work5", "work6", "work7", "work8"]);
}

module.exports = solitaire.freecell;
// Copyright 2005-2011 David Caldwell <david@greenfelt.net>, Jim Radford <radford@greenfelt.net>

var sht = require('./sht');
var solitaire = require('./solitaire').games;
var piles = require('./piles'), in_off_color_order=piles.in_off_color_order, drag_max_given_free=piles.drag_max_given_free;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;

solitaire.freecell = class extends sht {
    static {
        this.prototype.work_pile = class extends sht.prototype.work_pile {
                card_order = in_off_color_order;
                drag_max() { return (this.game.freetemps()+1) * drag_max_given_free(this.game.work,this); }
                valid_top_card(card) { return true; } // Accept any card in a blank space
                maxstack = Math.ceil(9.77615472612623); // Determined by query in upgrades/maxstack.sql
        };
        this.prototype.work_piles = 8;
    }
    layout = grid(["temp1", "temp2", "temp3", "temp4", "good1", "good2", "good3", "good4"],
                  ["work1", "work2", "work3", "work4", "work5", "work6", "work7", "work8"]);
}

module.exports = solitaire.freecell;
